import { Loader2 } from 'lucide-react'

export default function FullPageSpinner() {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <Loader2 className="h-16 w-16 animate-spin text-primary" />
    </div>
  )
}
